<template>
  <div class="grid grid-cols-4">
    <section v-if="events.length" class="col-span-full grid *:px-4 *:pb-4 xl:*:py-0">
      <div class="z-10 col-span-full xl:col-span-3 py-4 mt-10 mb-8">
        <h3 class="text-app-primary-1-red--fire-brick font-medium text-2xl xl:text-4xl">{{ $t('recommendation.suggestion-page.other-suggestions-title') }}</h3>
        <p class="">({{ events.length }} {{ $t('recommendation.suggestion-page.other-suggestions-found') }})</p>
      </div>
      <ul class="col-span-full xl:col-span-3">
        <li v-for="(suggestedEventUri, index) of events" :key="index" class="mb-6">
          <OrganismLoaderFromUri :uri="suggestedEventUri.uri">
            <template #loading>
              <MoleculeCardEventAndSeries :loading="true" />
            </template>
            <template #default="event">
              <MoleculeCardEventAndSeries
                :end-date="event.eventEndDate ? new Date(event.eventEndDate) : undefined"
                :event-id="event.iConcertId"
                :image="get(event, 'production.teaserImage')"
                :location="get(event, 'room.title')"
                :title="get(event, 'production.title')"
                :tix-pricing="{ minPrice: event.minPrice }"
                :url="event.url"
                :when="new Date(event.eventDate)"
              />
            </template>
          </OrganismLoaderFromUri>
        </li>
      </ul>
    </section>
  </div>
</template>

<script setup lang="ts">
import get from 'lodash/get'

defineProps({
  events: { type: Array as PropType<any[]>, required: true },
})
</script>

<style scoped lang="scss"></style>
